import React, { useEffect, useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import axiosInstance from '../axiosConfig';
import './EntityModals.css';

function StorageCategoryModal({ show, handleClose, onSubmit }) {
    const [name, setName] = useState('');
    const [parent, setParent] = useState('');
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        if (show) {
            // Загружаем категории хранения при открытии модального окна
            axiosInstance.get('/api/storage-categories/')
                .then(response => {
                    setCategories(response.data.categories || []);
                })
                .catch(error => {
                    console.error('Ошибка при загрузке категорий хранения:', error);
                });
        }
    }, [show]);

    const handleFormSubmit = (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append('name', name);
        formData.append('parent', parent);

        axiosInstance.post('/api/create_storage_category/', formData)
            .then(response => {
                if (response.data.success) {
                    onSubmit(response.data);
                    setName('');
                    setParent('');
                    handleClose();
                } else {
                    console.error('Ошибка при создании категории хранения:', response.data.errors);
                }
            })
            .catch(error => {
                console.error('Ошибка при создании категории хранения:', error);
            });
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            centered
            className="entity-modal"
            dialogClassName="entity-modal-dialog entity-modal-dialog--sm"
            contentClassName="entity-modal-content"
        >
            <Modal.Header closeButton>
                <Modal.Title>Добавить место хранения</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleFormSubmit} className="entity-form">
                    <Form.Group controlId="formName" className="entity-field">
                        <Form.Label className="entity-label">Название</Form.Label>
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </Form.Group>
                    <Form.Group controlId="formParent" className="entity-field">
                        <Form.Label className="entity-label">Родительская категория</Form.Label>
                        <Form.Control
                            as="select"
                            value={parent}
                            onChange={(e) => setParent(e.target.value)}
                        >
                            <option value="">Выберите родительскую категорию</option>
                            {categories.map(category => (
                                <option key={category.id} value={category.id}>
                                    {category.name}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>
                    <div className="entity-actions">
                        <Button className="entity-btn entity-btn-primary" type="submit">
                            Сохранить
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default StorageCategoryModal;
